import styled from "styled-components";

export default styled.div`
  .search-home-page {
    .input-searcher {
      display: none;
    }

    margin-top: 4rem;
    margin-bottom: 4rem;
    .title {
      margin-bottom: 2rem;
    }
  }

  @media screen and (max-width: 768px) {
    .search-home-page {
      .input-searcher {
        display: block;
        margin-bottom: 2rem;
      }

      .title {
      }
    }
  }
`;
